import { Routes, Route, BrowserRouter } from "react-router";
import Layout from "./components/Layout";
import Explorer from "./pages/Explorer";
import AuthWrap from "./components/dialogs/AuthWrap";
import FindRestaurant from "./pages/Home/FindRestaurant";
import Profile from "./pages/Profile";
import Onboarding from "./components/dialogs/Onboarding";
import Upgrade from "./pages/Upgrade";
import type { FC, ReactNode } from "react";
import RestaurantDetails from "./pages/Explorer/components/RestaurantDetails";
import SubscriptionsAndPayment from "./pages/SubscriptionsAndPayment";
import Restaurant from "./pages/Restaurant";
import Favorites from "./pages/Favorites";
import Favorite from "./pages/Favorite";
import PublicRestaurant from "./pages/PublicRestaurant";
import Restaurants from "./pages/Restaurants";
import GridBuilder from "./pages/GridBuilder";
import Grid from "./pages/GridBuilder/Grid";
import CreateOrEditGrid from "./pages/GridBuilder/CreateOrEditGrid";
import OnboardingAddRestaurants from "./pages/Home/components/OnboardingAddRestaurants";
import ConnectorsPage from "./pages/Connectors";
import NewHomePage from "./pages/Home/components/NewHomePage";

type Props = {
  children: ReactNode;
};

const Router: FC<Props> = ({ children }) => {
  return (
    <BrowserRouter>
      {children}

      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/" element={<NewHomePage />}>
            <Route
              path="/onboarding-add-restaurants"
              element={<OnboardingAddRestaurants />}
            />
          </Route>

          {/* Explorer */}
          <Route path="explorer" element={<Explorer />}>
            <Route
              path="restaurant/:restaurantId"
              element={<RestaurantDetails />}
            />

            {/* Onboarding */}
            <Route path="onboarding" element={<Onboarding />} />

            {/* Auth */}
            <Route path="sign-in" element={<AuthWrap />} />
            <Route path="sign-up" element={<AuthWrap />} />
            <Route path="reset-password" element={<AuthWrap />} />
            <Route path="confirm" element={<AuthWrap />} />
          </Route>

          {/* Others */}
          <Route path="profile" element={<Profile />} />
          <Route path="subscriptions" element={<SubscriptionsAndPayment />} />
          <Route path="upgrade" element={<Upgrade />} />
          <Route path="find-restaurant" element={<FindRestaurant />} />

          {/* Restaurants */}
          <Route path="restaurants" element={<Restaurants />} />
          <Route path="restaurant/:restaurantId" element={<Restaurant />} />

          {/* Favorites */}
          <Route path="favorites" element={<Favorites />} />
          <Route path="favorite/:favoriteId" element={<Favorite />} />

          {/* Grid builder */}
          <Route path="grid-builder" element={<GridBuilder />} />
          <Route path="grid-builder/create" element={<CreateOrEditGrid />} />
          <Route
            path="grid-builder/edit/:gridId"
            element={<CreateOrEditGrid />}
          />
          <Route path="grid-builder/:gridId" element={<Grid />} />

          {/* Connectors */}
          <Route path="connectors" element={<ConnectorsPage />} />
        </Route>

        {/* Public */}
        <Route path="public">
          <Route path="restaurant/:restaurantId" element={<PublicRestaurant />}>
            <Route path="sign-in" element={<AuthWrap />} />
            <Route path="sign-up" element={<AuthWrap />} />
            <Route path="reset-password" element={<AuthWrap />} />
            <Route path="confirm" element={<AuthWrap />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
